// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5392":"9e962f7a","8005":"b3249b30"}[chunkId] + ".chunk.css";
};